import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getDashboardDataThunk, userDashboardDataThunk } from './dashboardThunk'

const initialState = {
	dashboardData: null,
	userDashBoardData: null,
}
export const getDashboardData = createAsyncThunk('user/getDashboardData', getDashboardDataThunk)
export const userDashboardData = createAsyncThunk('user/userDashboardData', userDashboardDataThunk)

const dashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getDashboardData.fulfilled, (state, action) => {
			state.dashboardData = action?.payload?.data?.data
		})
		builder.addCase(userDashboardData.fulfilled, (state, action) => {
			state.userDashBoardData = action?.payload?.data?.data
		})
	},
})

export default dashboardSlice.reducer
